import { Component, Input } from '@angular/core';

import { clienteCarteiraTipoProjetada } from '../../cliente-carteira-tipo';

@Component({
    selector: 'sgt-cliente-carteira-tipo-projetada-badge',
    templateUrl: './cliente-carteira-tipo-projetada-badge.component.html',
    styleUrls: ['./cliente-carteira-tipo-projetada-badge.component.less']
})
export class ClienteCarteiraTipoProjetadaBadgeComponent {
    tipo = clienteCarteiraTipoProjetada;

    /** Se o badge está inserido dentro dos badges do título de um card no pipeline */
    @Input() isPipelineCardTitleBadge = false;
}
